import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges } from '@angular/core';

import { ThemeService } from 'ngx-elvis-ds';
import { BaseComponent, Helpers } from 'ngx-elvis-ds';
import { ImageHelpers } from 'src/app/base/image-helpers';
import { ConfigService } from 'src/app/config.service';

@Component({
  selector: 'elv-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent extends BaseComponent implements OnInit, OnChanges {

  @ViewChild('button', { static: true }) button: ElementRef;
  @Input() color: string = 'dark';
  @Input() height: Number;

  @Input() image: string;
  @Input() label: string;
  @Input() price: number;
  @Input() code: string;
  @Input() disabled: boolean;

  constructor(
    private themes: ThemeService,
    public configSvc: ConfigService,
  ) {
    super();
  }

  ngOnChanges() {
    this.styleInit();
  }

  ngOnInit() {
    this.styleInit();
    this.themes.events.subscribe(() => { this.styleInit(); });
  }

  // private

  private styleInit() {
    if (this.height) {
      this.button.nativeElement.style.setProperty('--elv-height', `${this.height}px`);
    }

    if (this.color) {
      this.button.nativeElement.style.setProperty('--elv-color', `var(--ion-color-${this.color})`);
      this.button.nativeElement.style.setProperty('--elv-color-rgb', `var(--ion-color-${this.color}-rgb)`);
      this.button.nativeElement.style.setProperty('--elv-color-tint', `var(--ion-color-${this.color}-tint)`);
      this.button.nativeElement.style.setProperty('--elv-color-tint-rgb', `var(--ion-color-${this.color}-tint-rgb)`);
      this.button.nativeElement.style.setProperty('--elv-color-shade', `var(--ion-color-${this.color}-shade)`);
      this.button.nativeElement.style.setProperty('--elv-color-shade-rgb', `var(--ion-color-${this.color}-shade-rgb)`);
      this.button.nativeElement.style.setProperty('--elv-color-contrast', `var(--ion-color-${this.color}-contrast)`);
      this.button.nativeElement.style.setProperty('--elv-color-contrast-rgb', `var(--ion-color-${this.color}-contrast-rgb)`);
    }

    try {
      if (this.image.indexOf('http') === 0) {
        return;
      }
    } catch (error) {
      
    }

    if (this.image) {
      this.image = ImageHelpers.getImageURL('velocity-code-images', this.image, this.configSvc);
      this.button.nativeElement.style.setProperty('background-image', `url(${this.image})`);
    } else {
      if (this.code && this.configSvc) {
        this.image = ImageHelpers.getImageURL('velocity-code-images', `${this.code}.jpg`, this.configSvc);
        this.button.nativeElement.style.setProperty('background-image', `url(${this.image})`);
      } else {
        this.button.nativeElement.style.setProperty('background-image', 'linear-gradient( 170deg, var(--elv-color-tint), var(--elv-color) )');
      }
    }
  }

}
